export function setUrlValue(location, navigate, newSearch) {
    if (location.search.replace('?', '') !== newSearch) {
        navigate(Object.assign(Object.assign({}, location), { search: '?' + newSearch }));
    }
}
export function toFilters(location, navigate, keys, urlSearchParams) {
    const paramsObj = keys.reduce((memo, k) => {
        var _a;
        const key = k;
        const allValues = urlSearchParams.getAll(key);
        return Object.assign(Object.assign({}, memo), { [key]: {
                value: (_a = urlSearchParams.get(key), (_a !== null && _a !== void 0 ? _a : undefined)),
                values: allValues.length === 0 ? undefined : allValues,
                set: (value) => {
                    if (Array.isArray(value)) {
                        urlSearchParams.delete(key);
                        for (const v of value) {
                            urlSearchParams.append(key, v);
                        }
                    }
                    else if (value == null) {
                        urlSearchParams.delete(key);
                    }
                    else {
                        urlSearchParams.set(key, value);
                    }
                    setUrlValue(location, navigate, urlSearchParams.toString());
                },
            } });
    }, {});
    return paramsObj;
}
//# sourceMappingURL=utils.js.map